module.exports = __webpack_public_path__ + "static/media/jogging_track_day.d2d92768.jpg";